import type { ComponentType } from '@integrations/react'
import BankOutlineIcon from '../BankOutlineIcon'
import CardIcon from '../CardIcon'
import CashIcon from '../CashIcon'
import CryptoIcon from '../CryptoIcon'
import VoucherIcon from '../VoucherIcon'
import WalletIcon from '../WalletIcon'

export type PaymentMethodKind = 'bank' | 'card' | 'wallet' | 'cash' | 'crypto' | 'voucher'

/** Groups a payment method into the icon family shown for it. */
export function methodKind(method = ''): PaymentMethodKind {
  const m = method.toUpperCase()
  if (m.includes('CRYPTO') || m.includes('USDT') || m.includes('BTC')) return 'crypto'
  if (m.includes('CARD')) return 'card'
  if (m.includes('BOLETO') || m.includes('VOUCHER') || m.includes('OXXO')) return 'voucher'
  if (m.includes('CASH')) return 'cash'
  if (['BANK', 'SEPA', 'SWIFT', 'WIRE', 'TRANSFER', 'INTERAC'].some((key) => m.includes(key))) return 'bank'
  if (m.includes('WALLET') || m.includes('ALIPAY') || m.includes('PAY')) return 'wallet'
  return 'bank'
}

const KIND_ICONS: Record<PaymentMethodKind, ComponentType<{ size?: number }>> = {
  bank: BankOutlineIcon,
  card: CardIcon,
  wallet: WalletIcon,
  cash: CashIcon,
  crypto: CryptoIcon,
  voucher: VoucherIcon
}

interface Props {
  method: string
  size?: number
}

function PaymentMethodIcon({ method, size = 14 }: Props) {
  const Icon = KIND_ICONS[methodKind(method)]
  return <Icon size={size} />
}

export default PaymentMethodIcon
